import { Button, Col, Row } from 'antd';
import styled from 'styled-components';

const ButtonAddEmailField = styled(Button)`
  display: flex;

  margin-bottom: 10px;
  margin-top: 10px;
  width: 60px;
  height: 35px;
  align-items: center;
  justify-content: center;
  color: ${({ theme }) => theme['primary-color']} !important;
`;

const ButtonRemoveEmailField = styled(Button)`
  display: flex;
  justify-content: center;
  border: none;
  background: transparent;
  box-shadow: none;
  margin-left: 10px;
  margin-bottom: 10px;
  :hover {
    background: transparent;
  }
`;

const ColIconRemove = styled(Col)`
  margin: auto;
`;

const ContainerAlternative = styled(Row)`
vertical-align: center;
align-items: center;
align-content: center;
div{
  margin-bottom: 20px !important;
}
  input {
    width: 100% !important;
  }
`;

export { ButtonAddEmailField, ButtonRemoveEmailField, ColIconRemove, ContainerAlternative };
